export type NavItem =
  | { type: 'link'; label: string; slug: string; dataTestId?: string }
  | { type: 'dropdown'; slug: string };

export const NAV_ITEMS: NavItem[] = [
  { type: 'link', label: 'Home', slug: '/' },
  {
    type: 'link',
    label: 'Browse Plans by ZIP Code',
    slug: '/browse/plans',
    dataTestId: 'pick-a-plan-simplified',
  },
  { type: 'link', label: 'New to Medicare', slug: '/new-to-medicare' },
  { type: 'dropdown', slug: '/medicare-university' },
  { type: 'link', label: 'About Us', slug: '/about-us' },
];
